export default __webpack_public_path__ + "static/media/93_mobile.a5b2a9e8.jpg";